module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-open_new-white-2d0b57eb.svg";